import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledLastMinute } from './style';
import Icon from '../Icon';
import { Close } from '../../../../assets/images';

import { getLastMinutes } from '../../../utils/apiLastMinute';

class LastMinute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLastMinute: true,
      dataLastMinute: null
    };
  }

  componentDidMount() {
    getLastMinutes(10, 0).then(data =>
      this.setState({ dataLastMinute: data.content })
    );
  }

  closeLastMinute = () => {
    this.setState({
      showLastMinute: false
    });
  };

  render() {
    const { className } = this.props;
    const { showLastMinute, dataLastMinute } = this.state;

    return (
      showLastMinute &&
      dataLastMinute &&
      dataLastMinute.length > 0 && (
        <StyledLastMinute className={className}>
          <Icon
            className="close"
            svg={Close}
            size="m"
            onClick={this.closeLastMinute}
          />
          <ul className="list">
            {dataLastMinute &&
              dataLastMinute.map(LM => (
                <li className="item" key={`id-${LM.id}`}>
                  <span>{LM.text}</span>
                </li>
              ))}
          </ul>
        </StyledLastMinute>
      )
    );
  }
}

LastMinute.propTypes = {
  className: PropTypes.string
};

export default LastMinute;
